export const COB_MONEY_SET_REQUESTED_LIMIT = 'COB_MONEY_SET_REQUESTED_LIMIT';
export const COB_MONEY_COMPONENT_COMPLETE = 'COB_MONEY_COMPONENT_COMPLETE';
export const COB_MONEY_SECTION_COMPLETE = 'COB_MONEY_SECTION_COMPLETE';
